import styled from "@emotion/styled"
import type { RoomBranding } from "../../recoil/atoms/room/types"
import TextareaAutosize from "react-textarea-autosize"

export interface StylesProps {
  roomStyles?: RoomBranding
  disableButton?: boolean
  error?: string
  errorMessage?: string
  isError?: boolean
  disabled?: boolean
  borderColor?: string
  isSmallWindowHeight?: boolean
}

export const Wrapper = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* background-color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBackground ?? "#fff"}; */
  flex-grow: 1;
  color: #1a202c;
`
export const Title = styled.h5<StylesProps>`
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "1rem" : "1.25rem"};
  line-height: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "1.2" : "1.5"};
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.2rem" : "0.4rem"};
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText &&
    roomStyles?.servicePanelElementPrimaryText};
`

export const Text = styled.p<StylesProps>`
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.75rem" : "1rem"};
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.2rem" : "0.4rem"};
  text-align: left;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementSecondaryText &&
    roomStyles?.servicePanelElementSecondaryText};
`
export const Error = styled.p`
  margin-top: 0.2rem;
  color: red !important;
`

export const Form = styled.form`
  width: 100%;
  margin-bottom: 0.4rem;
`

export const InputWrapper = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.2rem" : "0.5rem"};
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.35rem" : "0.5rem"};
  position: relative;
`

export const Input = styled.input<StylesProps>`
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ roomStyles }) =>
    roomStyles.servicePanelElementPrimaryText ?? "#495057"};
  background-color: ${({ roomStyles }) =>
    roomStyles.servicePanelElementBackground ?? "#e9ecef"};
  border: ${({ roomStyles, isError, borderColor }) =>
    roomStyles.servicePanelElementBorder
      ? `2px solid ${borderColor}`
      : "2px solid #ced4da"};
  border-radius: 0.3rem;
  padding: 0.375rem 0.75rem;

  &:hover {
    border-color: ${({ isError, roomStyles, disabled }) =>
      !disabled &&
      (isError
        ? roomStyles?.servicePanelElementWarningText ?? "red"
        : roomStyles.servicePanelElementBorder ?? "#CBD5E0")};
  }

  &:focus {
    border-color: ${({ errorMessage, roomStyles }) =>
      errorMessage
        ? roomStyles?.servicePanelElementWarningText ?? "red"
        : roomStyles.servicePanelElementBorder ?? "#718096"};
  }

  &:focus-visible {
    border-color: ${({ isError, roomStyles }) =>
      isError
        ? roomStyles?.servicePanelElementWarningText ?? "red !important"
        : roomStyles.servicePanelElementBackground
        ? `${roomStyles.servicePanelElementBackground} !!!important`
        : "#718096 !!!important"};
    outline: unset;
  }

  ::placeholder {
    color: ${({ roomStyles }) =>
      roomStyles.servicePanelElementPrimaryText ?? "#495057"};
    opacity: 0.5;
  }
`

export const Textarea = styled(TextareaAutosize)<StylesProps>`
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ roomStyles }) =>
    roomStyles.servicePanelElementPrimaryText ?? "#495057"};
  background-color: ${({ roomStyles }) =>
    roomStyles.servicePanelElementBackground ?? "#e9ecef"};
  border: ${({ roomStyles, borderColor }) =>
    roomStyles.servicePanelElementBorder
      ? `2px solid ${borderColor ?? roomStyles.servicePanelElementBorder}`
      : "2px solid #ced4da;"};
  border-radius: 0.3rem;
  padding: 0.375rem 0.75rem;
  min-height: 38px;
  resize: none;
  &:hover {
    border-color: ${({ error, roomStyles }) =>
      error
        ? roomStyles.servicePanelElementWarningText ?? "red !important"
        : roomStyles.servicePanelElementBorder ?? "#CBD5E0 !important"};
  }
  &:focus-visible {
    border-color: ${({ error, roomStyles }) =>
      error
        ? roomStyles.servicePanelElementWarningText ?? "red !important"
        : roomStyles.servicePanelElementBackground
        ? `${roomStyles.servicePanelElementBackground} !!!important`
        : "#718096 !!!important"};
    outline: unset;
  }
  ::placeholder {
    color: ${({ roomStyles }) =>
      roomStyles.servicePanelElementPrimaryText ?? "#495057"};
    opacity: 0.5;
  }
`

export const Button = styled.button<StylesProps>`
  border-radius: 0.25rem;
  padding: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.3rem 0.75rem" : "0.375rem 0.75rem"};
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.9rem" : "1rem"};
  cursor: pointer;
  margin-bottom: 1rem;
  width: 100%;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonBorderColor
      ? `1px solid ${
          roomStyles?.secondaryAccessButtonBorderColor
            ? roomStyles.secondaryAccessButtonBorderColor
            : "transparent"
        }`
      : "0px"};
  background-color: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonBackgroundColor || "#fff"};
  color: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonTextColor || "#fff"};
  &:hover {
    background-color: ${({ roomStyles }) =>
      roomStyles.secondaryAccessButtonMouseoverColor || "#fff"};
    color: ${({ roomStyles }) =>
      roomStyles.secondaryAccessButtonTextMouseoverColor || "#fff"};
  }
  &:disabled {
    opacity: 0.25;
    pointer-events: none;
    user-select: none;
    cursor: not-allowed !important;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const ShrinkedButton = styled(Button)`
  width: calc(100% - 40px);
`

export const ButtonWithIcon = styled.button`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  /*  &:hover {
    opacity: 0.7;
  } */
`

export const Icon = styled.div`
  height: 15px;
`

export const DeleteButton = styled(ButtonWithIcon)<StylesProps>`
  width: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "30px" : "30px"};
  height: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "30px" : "30px"};
  padding: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "7px 9px" : "10px 12px"};
  cursor: pointer;
  &:hover {
    /* color: ${({ roomStyles }) =>
      roomStyles?.servicePanelElementPrimaryText ?? "#e9ecef"}; */
    /* opacity: 1; */
  }

  &:disabled {
    opacity: 0.25;
    cursor: default;
  }
`
export const DeleteIcon = styled.div<StylesProps>`
  width: 100%;
  height: 100%;
  opacity: 0.75;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "grey"};
  &:hover {
    color: ${({ roomStyles }) =>
      roomStyles.servicePanelElementPrimaryText ?? "#e9ecef"};
    opacity: 1;
  }
`
